export const shoulderHawkinsText = {
  values: [
    { value: 'ShoulderHawkins', text: 'Ja', score: 1 },
    { value: 'ShoulderHawkins', text: 'Nei', score: 0 },
    { value: 'ShoulderHawkins', text: 'Ikke aktuelt', score: -1 },
  ],
};
